/**
 * Единый справочник подписей ИИ-агентов ОСНОВА по коду.
 *
 * Один источник правды для шапки (AppShell), раздела «Что нового» и любых
 * мест, где агент показывается по коду. Раньше карта дублировалась в двух
 * компонентах — держим её здесь, чтобы не расходились названия.
 */
export const AGENT_LABELS: Record<string, string> = {
  statut: 'ОСНОВА.Юрист',
  dispatcher: 'ОСНОВА.Диспетчер',
  smeta: 'ОСНОВА.Сметчик',
  postavka: 'ОСНОВА.МТО',
  field: 'ОСНОВА.Прораб',
  kadry: 'ОСНОВА.Кадры',
  econ: 'ОСНОВА.Экономист',
  pto: 'ОСНОВА.Инженер',
  mto: 'ОСНОВА.МТО',
  progress: 'ОСНОВА.Руководитель',
  ksp: 'ОСНОВА.КСП',
  meetings: 'ОСНОВА.Совещания',
  logist: 'ОСНОВА.Логист',
  geodesy: 'ОСНОВА.Геодезист',
  ceo: 'ОСНОВА.Гендиректор',
  finance: 'ОСНОВА.Финансист',
  archivist: 'ОСНОВА.Архивариус',
};

/**
 * Куда ведёт агент из меню и с дашборда. Обычно — `/agents/<код>`;
 * Архивариус живёт в окне Диска — Диск с открытой панелью.
 */
export function agentHref(code: string): string {
  return code === 'archivist' ? '/disk?archivist=1' : `/agents/${code}`;
}

/**
 * Коды агентов, к которым можно привязать карточку обновления. Синхронизировано
 * с backend `KNOWN_AGENT_CODES` (announce_common.rs): код вне этого набора
 * backend отклонит 400. `postavka` есть в AGENT_LABELS только для отображения
 * (в RBAC не заведён) — карточки к нему не создаём.
 */
export const ANNOUNCEABLE_AGENT_CODES = [
  'statut',
  'dispatcher',
  'smeta',
  'econ',
  'pto',
  'mto',
  'field',
  'meetings',
  'progress',
  'ksp',
  'logist',
  'geodesy',
  'kadry',
  'ceo',
  'finance',
] as const;

/**
 * Подпись агента по коду. `null`/пусто (общесистемное объявление) → «Система».
 * Неизвестный код возвращаем как есть — лучше сырой код, чем пустая метка.
 */
export function agentLabel(code: string | null | undefined): string {
  if (!code) return 'Система';
  return AGENT_LABELS[code] ?? code;
}

/**
 * Короткая подпись агента без префикса «ОСНОВА.» для боковой панели навигации.
 */
export function shortAgentLabel(code: string): string {
  const full = AGENT_LABELS[code] ?? code;
  return full.replace(/^ОСНОВА\./i, '');
}
